'use strict';

export default class SpinWidget extends React.Component {

    handleChange(dir) {
        const {maxValue = 10, minValue = 0, value, onChange} = this.props;
        if(dir) {
            onChange(Math.min(maxValue, value + 1))
        } else {
            onChange(Math.max(minValue, value - 1))
        }
    }

    render() {
        const {className, value, error, errorClass = 'error'} = this.props;
        return <div className={clsx(className, error && errorClass)}>
            <div className={clsx('search-spinner', {changed: value > 0})}>
                <i className="icon-people"></i>
                <input type="text" className="search-spinner__input" value={value} readOnly/>
                <a className="search-spinner__down" onClick={() => this.handleChange(false)}></a>
                <a className="search-spinner__up" onClick={() => this.handleChange(true)}></a>
            </div>
        </div>
    }
}
